import Axios from 'helpers/http'

let hostname = ''

switch (window.location.hostname) {
  case 'localhost':
    hostname = 'https://ssg-orbit-api.circleslife.co'
    break
  case 'ssg-orbit.circleslife.co':
    hostname = 'https://ssg-orbit-api.circleslife.co'
    break
  case 'orbit.circles.life':
    hostname = 'https://orbit-api.circles.life'
    break
  default:
    hostname = 'https://orbit-api.circles.life'
    break
}

const OrbitApiOps = new Axios(hostname, '/v1/labs/orbit')

export default OrbitApiOps
